import React from 'react';
import { FaCheck, FaExclamationTriangle, FaInfoCircle, FaTimes, FaTimesCircle } from 'react-icons/fa';
import './StatusToast.scss';

const iconMap = {
  success: FaCheck,
  error: FaTimes,
  warning: FaExclamationTriangle,
  info: FaInfoCircle
};

const StatusToast = ({ toast, onClose }) => {
  if (!toast?.message) {
    return null;
  }

  const Icon = iconMap[toast.type] || FaTimesCircle;
  const lines = toast.message.split('\n').filter(Boolean);

  return (
    <div className={`status-toast ${toast.type || 'info'}`} role="status" aria-live="polite">
      <div className="status-toast__icon">
        <Icon />
      </div>
      <div className="status-toast__content">
        {lines.map((line, index) => (
          <div
            key={`${line}-${index}`}
            className={index === 0 ? 'status-toast__title' : 'status-toast__detail'}
          >
            {line}
          </div>
        ))}
      </div>
      <button type="button" className="status-toast__close" onClick={onClose} aria-label="Kapat">
        <FaTimes />
      </button>
    </div>
  );
};

export default StatusToast;
